import { useEffect, useState } from 'react';
import { Toggle } from '@/components/ui';
import { adminApi } from '@/shared/api/adminApi';
import { toast } from '@/components/ui/Toast';

interface Did { id: number; number: string; type: string; recording_enabled: boolean }

/** הגדרות הקלטה — הקלטה אוטומטית לכל מספר נכנס (DID). */
export function RecordingSettings() {
  const [dids, setDids] = useState<Did[]>([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState<number | null>(null);

  useEffect(() => {
    void adminApi
      .dids()
      .then((res) => setDids((res.data as Did[]) ?? []))
      .catch(() => toast('שגיאה בטעינת מספרים', 'danger'))
      .finally(() => setLoading(false));
  }, []);

  async function toggle(did: Did, next: boolean) {
    setSaving(did.id);
    setDids((prev) => prev.map((d) => (d.id === did.id ? { ...d, recording_enabled: next } : d)));
    try {
      await adminApi.updateDid(did.id, { recording_enabled: next });
      toast(next ? `הקלטה הופעלה ל-${did.number}` : `הקלטה כובתה ל-${did.number}`, 'ok');
    } catch {
      setDids((prev) => prev.map((d) => (d.id === did.id ? { ...d, recording_enabled: !next } : d)));
      toast('שגיאה בעדכון', 'danger');
    } finally {
      setSaving(null);
    }
  }

  if (loading) return <div style={{ color: 'var(--muted)' }}>טוען…</div>;

  return (
    <div className="stack">
      <p style={{ color: 'var(--muted)', margin: 0, fontSize: 'var(--t-sm)' }}>
        הפעל או כבה הקלטה אוטומטית לכל מספר נכנס (DID). שיחות יוקלטו רק כאשר ההקלטה מופעלת על המספר או על התור.
      </p>
      {dids.length === 0 ? (
        <div style={{ color: 'var(--muted)' }}>אין מספרים מוגדרים.</div>
      ) : (
        <div style={{ display: 'grid', gap: 6 }}>
          {dids.map((d) => (
            <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 'var(--pad-row) var(--pad-card)', background: 'var(--surface-2)', borderRadius: 'var(--r-3)' }}>
              <div>
                <strong dir="ltr">{d.number}</strong>
                <span style={{ fontSize: 'var(--t-xs)', color: 'var(--muted)', marginInlineStart: 8 }}>{d.type}</span>
              </div>
              <Toggle checked={d.recording_enabled} onChange={(v) => toggle(d, v)} disabled={saving === d.id} label={d.recording_enabled ? 'מוקלט' : 'כבוי'} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
